<div class="modal fade" id="kt_modal_invoice_detail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header bg-light border-bottom">
        <h2 class="fw-bold text-dark">Invoice Form</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0" *ngIf="selectedInvoice">
        <form id="invoiceForm" [formGroup]="invoiceForm" (ngSubmit)="onSave()" novalidate>
          <!-- Top Action Buttons -->
          <div class="d-flex justify-content-between align-items-center p-4 bg-light border-bottom">
            <div class="d-flex gap-2">
              <input type="text" class="form-control form-control-sm w-200px" placeholder="Enter Stock Number" formControlName="stockNumberSearch">
              <button type="button" class="btn btn-sm btn-primary" (click)="searchInvoiceByStockNumber()" [disabled]="isSearchingInvoice">
                <span *ngIf="!isSearchingInvoice">SEARCH</span>
                <span *ngIf="isSearchingInvoice">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Searching...
                </span>
              </button>
              <!-- <button type="submit" class="btn btn-sm btn-success" [disabled]="isLoading"> -->
                <!-- <span *ngIf="!isLoading">SAVE</span> -->
                <!-- <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </span> -->
              <!-- </button> -->
            </div>
          <div class="d-flex gap-2">
            <span class="allocation-hover-container"
                  (mouseenter)="showAllocationTooltip($event)"
                  (mouseleave)="hideAllocationTooltip()">
              <button class="btn btn-sm btn-info allocation-trigger">Allocation</button>
              <div class="allocation-details-popup" *ngIf="hasAllocations()">
                <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden m-0">
                  <thead>
                    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
                      <td>Allocation Date</td>
                      <td>Payment Id</td>
                      <td>Amount USD</td>
                      <td>Rate</td>
                      <td>JPY Value</td>
                    </tr>
                  </thead>
                  <tbody class="text-gray-600 fw-semibold">
                    <tr *ngFor="let allocation of selectedInvoice?.allocations">
                      <td class="text-nowrap">{{ allocation.created_at | date:'yyyy-MM-dd' }}</td>
                      <td class="text-nowrap">{{ allocation.deposit_no }}</td>
                      <td class="text-nowrap">$ {{ allocation.amount_in_usd }}</td>
                      <td class="text-nowrap">{{ allocation.ex_rate }}</td>
                      <td class="text-nowrap">¥ {{ allocation.amount_in_jpy }}</td>
                    </tr>
                    <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
                      <td></td>
                      <td class="text-nowrap">Total Paid</td>
                      <td class="text-nowrap">$ {{ sumOfAllocations(selectedInvoice?.allocations || []) }}</td>
                      <td class="text-nowrap">{{ averageOfRate(selectedInvoice?.allocations || []) }}</td>
                      <td class="text-nowrap">¥ {{ sumOfAllocations(selectedInvoice?.allocations || [], 'jpy') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </span>
            <button type="button" class="btn btn-sm btn-secondary" (click)="cancelInvoice()" [disabled]="isLoading">Cancel</button>
            <button type="button" class="btn btn-sm btn-warning" style="text-transform: capitalize;">{{ selectedInvoice?.status || 'Pending' }} Invoice</button>
            <button type="button" class="btn btn-sm btn-primary">SHIP ID</button>
            <button type="button" class="btn btn-sm btn-success">INVOICE</button>
            <button type="button" class="btn btn-sm btn-info">CLIENTS</button>
          </div>
        </div>

        <!-- Success Message -->
        <!-- <div class="alert alert-success mx-4 mt-3 mb-0">
          <strong>Saved Successfully!</strong>
        </div> -->

        <!-- Main Form Content -->
        <div class="row g-0">
          <!-- Left Column -->
          <div class="col-md-8 p-4">
            <!-- Basic Information Row -->
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Approved Date</label>
                <input type="text" class="form-control form-control-sm" formControlName="approvedDate">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Invoice Date <span class="required"></span></label>
                <input type="text" class="form-control form-control-sm" formControlName="invoiceDate"
                  [class.is-invalid]="invoiceForm.get('invoiceDate')?.invalid && invoiceForm.get('invoiceDate')?.touched">
                <div class="invalid-feedback" *ngIf="invoiceForm.get('invoiceDate')?.invalid && invoiceForm.get('invoiceDate')?.touched">
                  Invoice Date is required
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Invoice Amount <span class="required"></span></label>
                <input type="text" class="form-control form-control-sm" formControlName="invoiceAmount"
                  [class.is-invalid]="invoiceForm.get('invoiceAmount')?.invalid && invoiceForm.get('invoiceAmount')?.touched">
                <div class="invalid-feedback" *ngIf="invoiceForm.get('invoiceAmount')?.invalid && invoiceForm.get('invoiceAmount')?.touched">
                  Invoice Amount is required
                </div>
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Approved By</label>
                <input type="text" class="form-control form-control-sm" formControlName="approvedBy">
              </div>
            </div>

            <!-- Note -->
            <div class="alert alert-warning mb-4" *ngIf="hasAllocations()">
              <strong>Note:</strong> You cannot change the customer as this invoice already has allocations
            </div>

            <!-- Vehicle Information -->
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Invoice No.</label>
                  <input type="text" class="form-control form-control-sm" formControlName="invoiceNo">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Stock Number# <span class="required"></span></label>
                  <input type="text" class="form-control form-control-sm" formControlName="stockNumber"
                    [class.is-invalid]="invoiceForm.get('stockNumber')?.invalid && invoiceForm.get('stockNumber')?.touched">
                  <div class="invalid-feedback" *ngIf="invoiceForm.get('stockNumber')?.invalid && invoiceForm.get('stockNumber')?.touched">
                    Stock Number is required
                  </div>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Chassis No.</label>
                  <input type="text" class="form-control form-control-sm" formControlName="chassisNo">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Lot Code</label>
                  <input type="text" class="form-control form-control-sm" formControlName="lotCode">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Engine Number</label>
                  <input type="text" class="form-control form-control-sm" formControlName="engineNumber">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Engine Type</label>
                  <select class="form-select form-select-sm" formControlName="engineType">
                    <option value="">Select Engine Type</option>
                    <option value="DA AT SIGHT">DA AT SIGHT</option>
                  </select>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Pay Terms</label>
                  <input type="text" class="form-control form-control-sm" formControlName="payTerms">
                </div>
              </div>

              <!-- Middle Column -->
              <div class="col-md-4">
                <!-- User Search for Consignee -->
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Search User (Consignee)</label>
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Search User"
                      [(ngModel)]="userSearchTerm"
                      [ngModelOptions]="{standalone: true}"
                      (input)="onUserSearchInput($event)"
                      (focus)="onUserInputFocus()"
                      (blur)="onUserInputBlur()"
                      [disabled]="hasAllocations()"
                      autocomplete="off" />

                    <!-- Loading Spinner -->
                    <div *ngIf="isUserSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </div>

                    <!-- Clear Button -->
                    <div *ngIf="userSearchTerm && !isUserSearching" class="position-absolute top-50 end-0 translate-middle-y">
                      <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="clearUserSearch()" title="Clear">
                        <i class="ki-duotone ki-cross fs-6">
                          <span class="path1"></span>
                          <span class="path2"></span>
                        </i>
                      </button>
                    </div>

                    <!-- Dropdown Results -->
                    <div *ngIf="showUserDropdown" class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border" style="z-index: 1050; max-height: 300px; overflow-y: auto;">
                      <div *ngIf="userSearchResults.length === 0 && !isUserSearching" class="dropdown-item-text text-muted text-center py-3">
                        No users found
                      </div>
                      <a
                        *ngFor="let user of userSearchResults"
                        href="javascript:void(0)"
                        class="dropdown-item d-flex align-items-center py-2"
                        (click)="selectUser(user)">
                        <div class="d-flex flex-column">
                          <span class="fw-bold text-gray-800">{{ getUserDisplayName(user) }}</span>
                          <small class="text-muted" *ngIf="user.city || user.country">{{ user.city }}{{ user.city && user.country ? ', ' : '' }}{{ user.country }}</small>
                          <small class="text-muted" *ngIf="user.phone">Phone: {{ user.phone }}</small>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Consignee</label>
                  <textarea class="form-control form-control-sm" rows="2" formControlName="consignee"></textarea>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Consignee Name</label>
                  <input type="text" class="form-control form-control-sm" formControlName="consigneeName">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Email</label>
                  <input type="email" class="form-control form-control-sm" formControlName="consigneeEmail"
                    [class.is-invalid]="invoiceForm.get('consigneeEmail')?.invalid && invoiceForm.get('consigneeEmail')?.touched">
                  <div class="invalid-feedback" *ngIf="invoiceForm.get('consigneeEmail')?.invalid && invoiceForm.get('consigneeEmail')?.touched">
                    Please enter a valid email address
                  </div>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Phone</label>
                  <input type="text" class="form-control form-control-sm" formControlName="consigneePhone">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Address</label>
                  <textarea class="form-control form-control-sm" rows="2" formControlName="consigneeAddress"></textarea>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">City</label>
                  <input type="text" class="form-control form-control-sm" formControlName="consigneeCity">
                </div>

                <!-- Same as Consignee Checkbox -->
                <div class="mb-2">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="sameAsConsignee" formControlName="sameAsConsignee">
                    <label class="form-check-label fw-semibold fs-7" for="sameAsConsignee">
                      Same as Consignee
                    </label>
                  </div>
                </div>

                <!-- Notify Party Section -->
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Notify Party</label>
                  <input type="text" class="form-control form-control-sm" formControlName="notifyParty">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Notify Party Company</label>
                  <input type="text" class="form-control form-control-sm" formControlName="notifyPartyCompany">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Notify Party Name</label>
                  <input type="text" class="form-control form-control-sm" formControlName="notifyPartyName">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Email</label>
                  <input type="email" class="form-control form-control-sm" formControlName="notifyPartyEmail"
                    [class.is-invalid]="invoiceForm.get('notifyPartyEmail')?.invalid && invoiceForm.get('notifyPartyEmail')?.touched">
                  <div class="invalid-feedback" *ngIf="invoiceForm.get('notifyPartyEmail')?.invalid && invoiceForm.get('notifyPartyEmail')?.touched">
                    Please enter a valid email address
                  </div>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Phone</label>
                  <input type="text" class="form-control form-control-sm" formControlName="notifyPartyPhone">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Address</label>
                  <textarea class="form-control form-control-sm" rows="2" formControlName="notifyPartyAddress"></textarea>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">City</label>
                  <input type="text" class="form-control form-control-sm" formControlName="notifyPartyCity">
                </div>
              </div>

              <!-- Right Column -->
              <div class="col-md-4">
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Total Cost</label>
                  <input type="text" class="form-control form-control-sm" formControlName="totalCost">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Sales Price</label>
                  <input type="text" class="form-control form-control-sm" formControlName="salesPrice">
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Cooler Name</label>
                  <select class="form-select form-select-sm" formControlName="coolerName">
                    <option value="">--Select--</option>
                  </select>
                </div>
                <div class="mb-2">
                  <label class="form-label fw-semibold fs-7">Cooler No.</label>
                  <input type="text" class="form-control form-control-sm" formControlName="coolerNo">
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column - Comments -->
          <div class="col-md-4 bg-light p-4 border-start">
            <div class="mb-4">
              <label class="form-label fw-semibold fs-7">Notes</label>
              <textarea class="form-control form-control-sm" rows="4" formControlName="notes"></textarea>
            </div>
            <div class="mb-4">
              <label class="form-label fw-semibold fs-7">Admin Comments</label>
              <textarea class="form-control form-control-sm" rows="4" formControlName="adminComments"></textarea>
            </div>
          </div>
        </div>

        <!-- Financial Information Row -->
        <div class="row g-0 border-top">
          <div class="col-md-8 p-4">
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Insurance</label>
                <input type="text" class="form-control form-control-sm" formControlName="insurance">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Freight</label>
                <input type="text" class="form-control form-control-sm" formControlName="freight">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">CIF Amount</label>
                <input type="text" class="form-control form-control-sm" formControlName="cifAmount">
              </div>
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Bank</label>
                <select class="form-select form-select-sm" formControlName="bank">
                  <option value="">Select Bank</option>
                  <option *ngFor="let bank of banks" value="{{bank._id}}">{{bank.name}}</option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="form-label fw-semibold fs-7">Payment Due Date</label>
                <input type="date" class="form-control form-control-sm" formControlName="paymentDueDate">
              </div>
            </div>
          </div>
        </div>



        <!-- Shipping Information Section -->
        <div class="row g-0 border-top">
          <div class="col-12 p-4">
            <h5 class="fw-bold text-dark mb-4">Shipping Information</h5>

            <!-- First Row -->
            <div class="row mb-3">
              <!-- Ship Search -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Ship Name</label>
                <div class="position-relative">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search Ship"
                    [(ngModel)]="shipSearchTerm"
                    [ngModelOptions]="{standalone: true}"
                    (input)="onShipSearchInput($event)"
                    (focus)="onShipInputFocus()"
                    (blur)="onShipInputBlur()"
                    autocomplete="off" />

                  <!-- Loading Spinner -->
                  <div *ngIf="isShipSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                    <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                  </div>

                  <!-- Clear Button -->
                  <div *ngIf="shipSearchTerm && !isShipSearching" class="position-absolute top-50 end-0 translate-middle-y">
                    <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="clearShipSearch()" title="Clear">
                      <i class="ki-duotone ki-cross fs-6">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </button>
                  </div>

                  <!-- Dropdown Results -->
                  <div *ngIf="showShipDropdown" class="dropdown-menu show position-absolute w-100 mt-1 shadow-sm border" style="z-index: 1050; max-height: 300px; overflow-y: auto;">
                    <div *ngIf="shipSearchResults.length === 0 && !isShipSearching" class="dropdown-item-text text-muted text-center py-3">
                      No ships found
                    </div>
                    <a
                      *ngFor="let ship of shipSearchResults"
                      href="javascript:void(0)"
                      class="dropdown-item d-flex align-items-center py-2"
                      (click)="selectShip(ship)">
                      <div class="d-flex flex-column">
                        <span class="fw-bold text-gray-800">{{ getShipDisplayName(ship) }}</span>
                        <small class="text-muted">{{ ship.sailing_port }} → {{ ship.destination_port }}</small>
                        <small class="text-muted">Sailing: {{ formatDate(ship.sailing_date) }}</small>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <!-- Age Name -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Age Name</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="ageName" readonly>
              </div>

              <!-- Carrier Name -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Carrier Name</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="carrierName" readonly>
              </div>

              <!-- Voyage Number -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Voyage Number</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="voyageNumber" readonly>
              </div>
            </div>

            <!-- Second Row -->
            <div class="row mb-3">
              <!-- Sailing Date -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Sailing Date</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="sailingDate" readonly>
              </div>

              <!-- Sailing Port -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Sailing Port</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="sailingPort" readonly>
              </div>

              <!-- Destination Port -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Destination Port</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="destinationPort" readonly>
              </div>

              <!-- Destination Country -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Destination Country</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="destinationCountry" readonly>
              </div>
            </div>

            <!-- Third Row -->
            <div class="row mb-3">
              <!-- Arrival Date -->
              <div class="col-md-3 mb-3">
                <label class="form-label fw-semibold fs-7">Arrival Date</label>
                <input type="text" class="form-control form-control-sm bg-light" formControlName="arrivalDate" readonly>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="submit" class="btn btn-primary" form="invoiceForm" [disabled]="isLoading">
          <span *ngIf="!isLoading">Save Changes</span>
          <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Saving...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
